export const INTERNAL_DOMAINS: ReadonlySet<string> = new Set([
  'nmviajes.com',
  'nmviajes-it.com',
  'localhost',
]);
